import { render, staticRenderFns } from "./PreviewHeader.vue?vue&type=template&id=163e0c32&scoped=true&"
import script from "./PreviewHeader.vue?vue&type=script&lang=js&"
export * from "./PreviewHeader.vue?vue&type=script&lang=js&"
import style0 from "./PreviewHeader.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./PreviewHeader.vue?vue&type=style&index=1&id=163e0c32&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163e0c32",
  null
  
)

export default component.exports